import isValidEmail from "util/validation/isValidEmail";

export default function isValidEmailList(value) {
    const items = value.split(',');
    const valid = items.map(function(email) {
        return isValidEmail(email);
    });
    return valid.indexOf(false) === -1;
}